import { useState, useEffect } from 'react'

import useTranslations from '../i18n/useTranslations'
import DownloadInstallJSPMAppUI from '../ui/views/DownloadInstallJSPMApp'

const OPERATING_SYSTEMS = {
  mac: {
    name: 'Mac OS',
    installationUrl: '/software/jspm5-5.0.23.503-universal.pkg',
    instructionsUrl: '/documents/Instrucciones_mac.pdf',
  },
  windows: {
    name: 'Windows',
    installationUrl: '/software/jspm5-5.0.23.503-win.exe',
    instructionsUrl: '/documents/Instrucciones_windows.pdf',
  },
}

const DownloadInstallJSPMApp = () => {
  const formatMessage = useTranslations()

  const [state, setState] = useState({
    isLoadingFiles: true,
    operatingSystem: getOperatingSystem(),
    softwareLicenseAgreementUrl: 'https://www.neodynamic.com/downloads/jspm/',
    otherVersionUrl: 'https://www.neodynamic.com/downloads/jspm/',
    recommendedVersion: undefined,
    installationInstructions: undefined,
  })

  useEffect(() => {
    const fetchFiles = async () => {
      const operatingSystem = getOperatingSystem()

      if (operatingSystem === undefined) {
        setState(state => ({
          ...state,
          isLoadingFiles: false,
        }))
        return
      }

      const instructionsBlob = await fetchFile(operatingSystem.instructionsUrl)
      const installationBlob = await fetchFile(operatingSystem.installationUrl)
      const installationSize = installationBlob.size / 1024 / 1024

      setState(state => ({
        ...state,
        isLoadingFiles: false,
        recommendedVersion: {
          text: operatingSystem.name,
          size: installationSize.toFixed(2),
          url: operatingSystem.installationUrl,
        },
        installationInstructions: {
          text: formatMessage('download-install-jspm-app:instructions-name', {
            operatingSystem: operatingSystem.name,
          }),
          url: URL.createObjectURL(instructionsBlob),
        },
      }))
    }

    fetchFiles()
  }, [formatMessage])

  return <DownloadInstallJSPMAppUI data={state} />
}

export default DownloadInstallJSPMApp

function getOperatingSystem() {
  const platform = window.navigator.platform.toLowerCase()

  if (platform.includes('mac')) return OPERATING_SYSTEMS.mac
  if (platform.includes('win')) return OPERATING_SYSTEMS.windows
  if (platform.includes('linux')) return OPERATING_SYSTEMS.linux

  return undefined
}

async function fetchFile(fileUrl) {
  try {
    const file = await fetch(process.env.PUBLIC_URL + fileUrl)
    const blob = await file.blob()

    return blob
  } catch (error) {}
}
